import { render, staticRenderFns } from "./ContestPage.vue?vue&type=template&id=824c1044&scoped=true"
import script from "./ContestPage.vue?vue&type=script&lang=js"
export * from "./ContestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824c1044",
  null
  
)

export default component.exports